/* Totkind Custom — trang san pham (05/10/2026). Form tu sinh tu mau ban 3 + ve xem thu ngay trong trinh duyet.
 *
 * Khoi theme blocks/tk-custom.liquid in ra: <div id="tk-custom" data-api="https://api.totkind.com/tkc" data-handle="...">.
 * Luong:
 *   1. Tai cau hinh  GET {api}/sp/<handle>.json  (mat xem thu, cac o khach dien, thu vien, font).
 *   2. Dung form: o CHON (o mau / anh nho), o CHU (dem ky tu), o TAI (anh sieu am: tai len + phong to + keo tren anh xem thu).
 *   3. Moi thay doi -> ve lai canvas (cung luat voi may chu: lop.phang + ve.js).
 *   4. Bam Add to cart: kiem o bat buoc; gan properties vao form (_ten tung o + _Preview + _Production, deu an o checkout);
 *      gui {ma, mau, handle, gt} len {api}/dat bang sendBeacon de may chu dong bang don.
 */
(function () {
  'use strict';
  if (window.TKC) return;
  /* 06/10: dung NHIEU LAN — trang san pham (che 'pdp') va hop "Edit design" trong cart drawer (che 'sua', tk-cart.js). */
  function TKC(goc, opts) {
  opts = opts || {};
  var CHE = opts.che || 'pdp';
  var API = (opts.api || goc.getAttribute('data-api') || 'https://api.totkind.com/tkc').replace(/\/+$/, '');
  var HANDLE = opts.handle || goc.getAttribute('data-handle') || '';
  var cfg = null, gt = {}, anhDem = TKC.anhDem, fontDa = TKC.fontDa;
  /* 08/10: mon di kem "tat Noel cung thiet ke" (tk-upsell.js) doc thiet ke hien tai + nghe moi lan doi (su kien tkc:doi) */
  /* 16/10: CHI form trang SP (form 'sua' trong drawer / 'tat' trong popup tat khong duoc de len thiet ke ornament) */
  if (CHE === 'pdp') window.TKC_TRANG = function () { return cfg ? { mau: cfg.key, gt: gt } : null; };
  var CHO_PHEP = /[^\p{L}\p{M}\p{N} '’&.,!?\-]/gu;          /* chu cai, so, khoang trang va vai dau co ban */

  function chuMau(goiY) { return String(goiY || '').replace(/^\s*(Ex|e\.g\.)\s*:?\s*/i, '').replace(/\s*,?\s*\.{2,}\s*$/, '').trim(); }
  function el(t, cls, txt) { var e = document.createElement(t); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  /* ── lop.phang (chep tu server/lib/lop.js — giu dong bo) ── */
  function truong(o) { return o.truong || String(o.id); }
  function moiLop(ds, lam) { (ds || []).forEach(function (o) { lam(o); if (o.loai === 'nhom') moiLop(o.con, lam); }); }
  function timMuc(id) {
    var ns = (cfg.thuVien && cfg.thuVien.nhom) || {};
    for (var k in ns) for (var i = 0; i < (ns[k].muc || []).length; i++) if (ns[k].muc[i].id === id) return ns[k].muc[i];
    return null;
  }
  function bangChon() {
    var b = {};
    moiLop(cfg.xem.o, function (o) { if (o.loai === 'anh' && o.chon) b[truong(o)] = (typeof gt[truong(o)] === 'string' && gt[truong(o)]) || o.chon.macDinh || o.chon.xemThu || null; });
    return b;
  }
  /* 06/10 ban 4: dk = 1 dieu kien hoac MANG (tat ca dung): {lop,trong}|{lop,ngoai}|{giong:[a,b]}|{khac:[a,b]} */
  function dsDk(dk) { return !dk ? [] : Array.isArray(dk) ? dk : [dk]; }
  function mot(d, bang) {
    if (d.giong) return bang[d.giong[0]] != null && bang[d.giong[0]] === bang[d.giong[1]];
    if (d.khac) return bang[d.khac[0]] !== bang[d.khac[1]];
    if (!d.lop) return true;
    if (Array.isArray(d.ngoai)) return d.ngoai.indexOf(bang[d.lop]) < 0;
    return Array.isArray(d.trong) ? d.trong.indexOf(bang[d.lop]) >= 0 : true;
  }
  function datDk(dk, bang) { return dsDk(dk).every(function (d) { return mot(d, bang); }); }
  function oCha(f) { var ra = []; dsDk(f.dk).forEach(function (d) { if (d.lop) ra.push(d.lop); else (d.giong || d.khac || []).forEach(function (k) { ra.push(k); }); }); return ra; }
  /* chu ghep "{o1} & {o2}": o chon -> muc.chu||muc.ten; o chu -> khach go, chua go -> chu mau tu goi y */
  function dienKhuon(khuon, bang) {
    return String(khuon).replace(/\{([\w-]+)\}/g, function (_, k) {
      if (bang[k] != null) { var m = timMuc(bang[k]); return m ? (m.chu != null ? m.chu : m.ten) : ''; }
      var v = gt[k]; if (typeof v === 'string' && v.trim()) return v.trim();
      var f = theoTruong[k]; return f ? chuMau(f.goiY) : '';
    });
  }
  function phang(ds, bang) {
    var ra = [];
    (function di(lop, k) {
      (lop || []).forEach(function (o0) {
        if (o0.an || !datDk(o0.dk, bang)) return;
        var o = Object.assign({}, o0, { x: k.x + o0.x * k.w, y: k.y + o0.y * k.h, w: o0.w * k.w, h: o0.h * k.h, rot: (o0.rot || 0) + (k.rot || 0) });
        if (o.loai === 'nhom') return di(o0.con, { x: o.x, y: o.y, w: o.w, h: o.h, rot: o.rot });
        if (o.loai === 'anh') {
          if (o0.chon) { var m = timMuc(bang[truong(o0)]); if (!m) return; o.url = m.tep; o.urlTo = m.to || null; }
          else if (o0.theo && o0.theo.lop) { o.url = (o0.theo.bang || {})[bang[o0.theo.lop]] || o0.tep; if (!o.url) return; }
          else if (o0.tep) { o.url = o0.tep; o.urlTo = o0.to || null; } else return;   /* 03/11: urlTo = ban x2 (Real-ESRGAN) cho luc can ve to */
        } else if (o.loai === 'tai') {
          var v = gt[truong(o0)]; if (!v || !v.tep) return;
          o.url = API + '/tai/' + v.tep; o.zoom = v.zoom || 1; o.dx = v.dx || 0; o.dy = v.dy || 0; o.xoay = v.xoay || 0;
        } else if (!o.loai || o.loai === 'text') {
          /* chua go -> ve chu mau lay tu goi y ("Ex: Daddy,..." -> "Daddy") nhu pawfecthouse; anh san pham #1 render dung trang thai nay */
          if (o0.khuon) o.giaTri = dienKhuon(o0.khuon, bang);
          else if (o0.khachNhap !== false) { var g0 = gt[truong(o0)]; o.giaTri = typeof g0 === 'string' && g0 !== '' ? g0 : chuMau(o0.goiY); }
        }
        ra.push(o);
      });
    })(ds, { x: 0, y: 0, w: 1, h: 1, rot: 0 });
    return ra;
  }

  /* ── ve (chep luat tu server/lib/ve.js) ── */
  function taiAnh(url) {
    if (!anhDem[url]) anhDem[url] = new Promise(function (ok) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { ok(i); }; i.onerror = function () { ok(null); }; i.src = url; });
    return anhDem[url];
  }
  function hoFont(ten) { return 'tk-' + String(ten || '').replace(/\.[^.]+$/, '').replace(/[^a-z0-9-]/gi, '-'); }
  function napFont(ten) {
    if (!ten || fontDa[ten]) return fontDa[ten] || Promise.resolve();
    var url = (cfg.font || {})[ten];
    if (!url || !window.FontFace) return Promise.resolve();
    fontDa[ten] = new FontFace(hoFont(ten), 'url(' + url + ')').load().then(function (f) { document.fonts.add(f); }).catch(function () {});
    return fontDa[ten];
  }
  function beNgang(ctx, chu, gian) { if (!gian) return ctx.measureText(chu).width; var w = 0; for (var c of chu) w += ctx.measureText(c).width + gian; return w - gian; }
  function veChuGian(ctx, chu, x, y, gian, to) {
    if (!gian) { to ? ctx.strokeText(chu, x, y) : ctx.fillText(chu, x, y); return; }
    var cx = x; for (var c of chu) { to ? ctx.strokeText(c, cx, y) : ctx.fillText(c, cx, y); cx += ctx.measureText(c).width + gian; }
  }
  /* 08/10: chu cong theo ruy bang (o.cong = do vong / be ngang; >0 vong len) — giong lib/ve.js may chu */
  function cung(o, oW) {
    var s = (o.cong || 0) * oW; if (Math.abs(s) < 0.5) return null;
    var R = (oW * oW / 4 + s * s) / (2 * Math.abs(s));
    return { s: s, R: R, dai: 2 * R * Math.asin(Math.min(1, oW / (2 * R))) };
  }
  function veCong(ctx, chu, gian, cg, to) {
    var len = cg.s > 0, R = cg.R, dinh = -cg.s / 2, a = -beNgang(ctx, chu, gian) / 2;
    for (var c of chu) {
      var cw = ctx.measureText(c).width, th = (a + cw / 2) / R;
      ctx.save();
      ctx.translate(R * Math.sin(th), len ? dinh + R * (1 - Math.cos(th)) : dinh - R * (1 - Math.cos(th)));
      ctx.rotate(len ? th : -th);
      to ? ctx.strokeText(c, -cw / 2, 0) : ctx.fillText(c, -cw / 2, 0);
      ctx.restore();
      a += cw + gian;
    }
  }
  function veText(ctx, W, H, o) {
    var chu = (o.truoc || '') + (o.hoa ? String(o.giaTri || '').toUpperCase() : String(o.giaTri || '')) + (o.sau || '');
    if (!o.giaTri) chu = '';
    if (!chu) return;
    var ho = hoFont(o.font), oW = o.w * W, oH = o.h * H;
    var tran = Math.max(6, Math.floor(oH * (o.coMax || 1))), san = Math.max(4, Math.floor(oH * (o.coMin || 0.2))), co = san;
    var cg = cung(o, oW), rongToi = cg ? cg.dai * 0.96 : oW, caoToi = cg ? Math.max(oH - Math.abs(cg.s), oH * 0.45) : oH;
    for (var c = tran; c > san; c--) {
      ctx.font = c + 'px "' + ho + '"';
      var m = ctx.measureText(o.coFont ? 'Hgjy' : chu), cao = (m.actualBoundingBoxAscent || c * 0.72) + (m.actualBoundingBoxDescent || c * 0.2);
      if (beNgang(ctx, chu, (o.gianChu || 0) * c / 100) <= rongToi && cao <= caoToi) { co = c; break; }
    }
    var gian = (o.gianChu || 0) * co / 100;
    ctx.save();
    ctx.translate(o.x * W + oW / 2, o.y * H + oH / 2);
    if (o.rot) ctx.rotate(o.rot * Math.PI / 180);
    ctx.font = co + 'px "' + ho + '"';
    ctx.textBaseline = o.canhDoc === 'top' ? 'top' : o.canhDoc === 'bottom' ? 'bottom' : 'middle';
    ctx.textAlign = 'left';
    if (cg) ctx.textBaseline = 'middle';
    var rong = beNgang(ctx, chu, gian);
    var x0 = o.canh === 'left' ? -oW / 2 : o.canh === 'right' ? oW / 2 - rong : -rong / 2;
    var y0 = o.canhDoc === 'top' ? -oH / 2 : o.canhDoc === 'bottom' ? oH / 2 : 0;
    /* 09/10 giong lib/ve.js: coFont -> chan chu co dinh, khoi "Hgjy" nam giua o */
    if (o.coFont && !cg && (!o.canhDoc || o.canhDoc === 'middle')) {
      var mm = ctx.measureText('Hgjy'); ctx.textBaseline = 'alphabetic';
      y0 = ((mm.actualBoundingBoxAscent || co * 0.72) - (mm.actualBoundingBoxDescent || co * 0.2)) / 2;
    }
    if (o.bong && o.bong.bat) {
      var g = (o.bong.goc || 0) * Math.PI / 180;
      ctx.shadowColor = o.bong.mau || 'rgba(0,0,0,.5)'; ctx.shadowBlur = (o.bong.nhoe || 0) * co / 100;
      ctx.shadowOffsetX = Math.cos(g) * (o.bong.xa || 0) * co / 100; ctx.shadowOffsetY = Math.sin(g) * (o.bong.xa || 0) * co / 100;
    }
    if (o.vienDay > 0) { ctx.lineWidth = o.vienDay / 100 * co; ctx.strokeStyle = o.vienMau || '#000'; ctx.lineJoin = 'round'; cg ? veCong(ctx, chu, gian, cg, true) : veChuGian(ctx, chu, x0, y0, gian, true); }
    ctx.fillStyle = o.mau || '#000'; cg ? veCong(ctx, chu, gian, cg, false) : veChuGian(ctx, chu, x0, y0, gian, false);
    ctx.restore();
  }
  function duongKhung(ctx, khung, w, h) {
    ctx.beginPath();
    if (khung === 'tron') { ctx.ellipse(0, 0, w / 2, h / 2, 0, 0, Math.PI * 2); return; }
    if (khung === 'tim') {
      var x = -w / 2, y = -h / 2;
      ctx.moveTo(0, y + h * 0.3); ctx.bezierCurveTo(0, y, x, y, x, y + h * 0.3); ctx.bezierCurveTo(x, y + h * 0.6, 0, y + h * 0.8, 0, y + h);
      ctx.bezierCurveTo(0, y + h * 0.8, x + w, y + h * 0.6, x + w, y + h * 0.3); ctx.bezierCurveTo(x + w, y, 0, y, 0, y + h * 0.3); return;
    }
    ctx.rect(-w / 2, -h / 2, w, h);
  }
  function veTai(ctx, W, H, o, img, matNa) {
    var goc = (Number(o.xoay) || 0) * Math.PI / 180;
    var oW = o.w * W, oH = o.h * H, r = Math.max(oW / img.width, oH / img.height) * (o.zoom || 1) * (goc ? Math.abs(Math.cos(goc)) + Math.abs(Math.sin(goc)) : 1);
    var w = img.width * r, h = img.height * r, thuaX = (w - oW) / 2, thuaY = (h - oH) / 2;
    var p = document.createElement('canvas'); p.width = Math.ceil(oW); p.height = Math.ceil(oH);
    var px = p.getContext('2d');
    var nenA = o.nenAnh && anhDem[o.nenAnh] && anhDem[o.nenAnh].v;   /* 07/10: anh nen giong anh quang cao */
    if (nenA) { var sN = Math.max(oW / nenA.width, oH / nenA.height); px.drawImage(nenA, (oW - nenA.width * sN) / 2, (oH - nenA.height * sN) / 2, nenA.width * sN, nenA.height * sN); }
    else if (o.nenMau) {                              /* 07/10: o tach nen -> nen diu sau anh (giong lib/ve.js) */
      if (Array.isArray(o.nenMau)) { var g = px.createRadialGradient(oW / 2, oH * 0.42, 0, oW / 2, oH / 2, Math.max(oW, oH) * 0.62); g.addColorStop(0, o.nenMau[0]); g.addColorStop(1, o.nenMau[1] || o.nenMau[0]); px.fillStyle = g; }
      else px.fillStyle = o.nenMau;
      px.fillRect(0, 0, oW, oH);
    }
    px.translate(oW / 2, oH / 2); if (goc) px.rotate(goc); px.drawImage(img, -w / 2 - (o.dx || 0) * thuaX, -h / 2 - (o.dy || 0) * thuaY, w, h);
    px.setTransform(1, 0, 0, 1, 0, 0); px.globalCompositeOperation = 'destination-in';
    if (matNa) px.drawImage(matNa, 0, 0, oW, oH);
    else if (o.khung && o.khung !== 'chu-nhat') { px.translate(oW / 2, oH / 2); duongKhung(px, o.khung, oW, oH); px.fillStyle = '#000'; px.fill(); }
    ctx.save(); ctx.translate(o.x * W + oW / 2, o.y * H + oH / 2); if (o.rot) ctx.rotate(o.rot * Math.PI / 180);
    ctx.globalAlpha = o.mo == null ? 1 : o.mo; ctx.drawImage(p, -oW / 2, -oH / 2); ctx.restore();
  }

  /* ════════ Ban 2 (05/10 toi): trinh bay theo pawfecthouse (Teeinblue) ════════
     - Xem thu ve thang len ANH SAN PHAM DAU TIEN (anh ornament treo cay thong) — anh san pham = preview.
     - Nut "PREVIEW YOUR PERSONALIZATION" mo hop xem lon.
     - Form: khung xam nhat, o anh 59px co dau tich, gach dut giua cac nhom, o nhap co bo dem, dong goi y nghieng. */
  var dich = [], luotVe = 0, khungTai = null, canvasChinh = null;

  /* 03/11 (user: zoom 2 ngon cua Safari len preview van mo): biet muc zoom cua TRINH DUYET (visualViewport.scale) -> ve canvas to theo,
     dung ban x2; tha zoom thi ve nho lai cho nhe may. Gioi han 2600px vat ly (ban x2 nen ~2508px, du RAM iPhone). */
  var TRAN_PX = 2600;
  function zoomTrang() { var v = window.visualViewport; return v && v.scale > 1.05 ? Math.min(4, v.scale) : 1; }
  (function () {
    var v = window.visualViewport; if (!v) return;
    var cu = 1, hen = 0;
    v.addEventListener('resize', function () {
      clearTimeout(hen);
      hen = setTimeout(function () { var z = zoomTrang(); if (Math.abs(z - cu) < 0.25 && !(z === 1 && cu !== 1)) return; cu = z; if (dich.length) veLai(); }, 250);
    });
  })();
  function veLen(cv, nen, lop, toiDa) {
    var dpr = Math.min(3, window.devicePixelRatio || 1), css = (cv.parentNode && cv.parentNode.clientWidth) || 560;
    var rong = Math.max(200, Math.min(toiDa || 1000, css * (cv.__phong || 1))) * dpr;   /* __phong: khung noi ve to hon de zoom x4 van net */
    var zt = zoomTrang(); if (zt > 1) rong = Math.max(rong, css * dpr * zt);
    rong = Math.min(rong, Math.max(TRAN_PX, nen.width));
    var k = rong / nen.width, W = Math.round(nen.width * k), H = Math.round(nen.height * k);
    if (cv.width !== W) { cv.width = W; cv.height = H; }
    var ctx = cv.getContext('2d');
    /* 03/11: canvas can to hon anh nen goc (khung noi dang zoom, man hinh retina lon) -> dung ban x2; chua tai thi tai ngam roi ve lai */
    var net = k > 1.1 && cfg.xem && cfg.xem.anhTo, thieuNet = [];
    var lay = function (u, uTo) { if (net && uTo) { var p = anhDem[uTo]; if (p && p.v) return p.v; if (!p) thieuNet.push(uTo); } var q = anhDem[u]; return q && q.v; };
    ctx.clearRect(0, 0, W, H); ctx.drawImage(lay(cfg.xem.anh, net ? cfg.xem.anhTo : null) || nen, 0, 0, W, H);
    var tai = null;
    lop.forEach(function (o) {
      if (o.loai === 'nen') { ctx.save(); ctx.fillStyle = o.mau || '#fff'; ctx.globalAlpha = o.mo == null ? 1 : o.mo; ctx.fillRect(o.x * W, o.y * H, o.w * W, o.h * H); ctx.restore(); return; }
      if (o.loai === 'anh') {
        var img = lay(o.url, o.urlTo); if (!img) return;
        var oW = o.w * W, oH = o.h * H, w = oW, h = oH;
        if (o.giuTyLe !== false) { var r = Math.min(oW / img.width, oH / img.height); w = img.width * r; h = img.height * r; }
        ctx.save(); ctx.translate(o.x * W + oW / 2, o.y * H + oH / 2); if (o.rot) ctx.rotate(o.rot * Math.PI / 180);
        ctx.globalAlpha = o.mo == null ? 1 : o.mo; ctx.drawImage(img, -w / 2, -h / 2, w, h); ctx.restore();
        return;
      }
      if (o.loai === 'tai') {
        var ia = anhDem[o.url] && anhDem[o.url].v; if (!ia || !(ia.naturalWidth || ia.width)) return;
        var vaA = o.vaAnh && anhDem[o.vaAnh] && anhDem[o.vaAnh].v; if (vaA) ctx.drawImage(vaA, 0, 0, W, H);   /* 07/10: mieng va toan khung */
        veTai(ctx, W, H, o, ia, o.khung && anhDem[o.khung] && anhDem[o.khung].v); tai = { o: o, W: W, H: H };
        return;
      }
      veText(ctx, W, H, o);
    });
    if (thieuNet.length) taiNet(thieuNet);
    return tai;
  }
  var henNet = 0;
  function taiNet(ds) { Promise.all(ds.map(function (u) { return taiAnh(u); })).then(function () { clearTimeout(henNet); henNet = setTimeout(veLai, 30); }); }
  function veLai() {
    var so = ++luotVe;
    if (CHE === 'pdp') { try { document.dispatchEvent(new Event('tkc:doi')); } catch (e) {} }
    if (opts.doi) opts.doi(gt);
    if (daSanSang) luuLichSuSau();
    if (cfg.xemMay) { veMay(so); return; }
    var lop = phang(cfg.xem.o, bangChon());
    var can = [taiAnh(cfg.xem.anh)];
    lop.forEach(function (o) {
      if (o.url) can.push(taiAnh(o.url));
      if (o.loai === 'tai' && o.khung && /^(https?:|\/)/.test(o.khung)) can.push(taiAnh(o.khung));
      if (o.loai === 'tai' && o.nenAnh) can.push(taiAnh(o.nenAnh));
      if (o.loai === 'tai' && o.vaAnh) can.push(taiAnh(o.vaAnh));
      if ((!o.loai || o.loai === 'text') && o.font) can.push(napFont(o.font));
    });
    Promise.all(can).then(function () {
      if (so !== luotVe) return;
      var nen = anhDem[cfg.xem.anh] && anhDem[cfg.xem.anh].v; if (!nen) return;
      dich.forEach(function (d) {
        if (!d.cv.isConnected || (d.canHien && !d.cv.offsetParent)) return;
        var t = veLen(d.cv, nen, lop, d.toiDa);
        d.tai = t; if (d.sauVe) d.sauVe(t);
        if (d.cv === canvasChinh) khungTai = t;
      });
      if (dich[0] && dich[0].phu) dich[0].phu.classList.add('tkc-phu--san');
      taiTruocSau();
    });
  }
  /* 16/10: mau xemMay (tat Noel) -> xem thu = anh tat THAT do may chu ve (POST {api}/xt), khong ve lop phang trong trinh duyet */
  var henMay = 0;
  function veMay(so) {
    if (!dich.length) return;
    clearTimeout(henMay);
    henMay = setTimeout(function () {
      var rong = Math.min(1200, Math.round(Math.max.apply(null, dich.map(function (d) { return Math.min(d.toiDa || 760, (d.cv.parentNode && d.cv.parentNode.clientWidth) || 560); })) * Math.min(2, window.devicePixelRatio || 1)));
      fetch(API + '/xt', { method: 'POST', body: JSON.stringify({ mau: cfg.key, gt: gt, rong: rong }), headers: { 'Content-Type': 'text/plain' } })
        .then(function (r) { if (!r.ok) throw new Error('xt ' + r.status); return r.blob(); })
        .then(function (b) {
          var u = URL.createObjectURL(b), im = new Image();
          im.onload = function () {
            if (so === luotVe) dich.forEach(function (d) { if (d.cv.isConnected) veLen(d.cv, im, [], d.toiDa); });
            if (so === luotVe && dich[0] && dich[0].phu) dich[0].phu.classList.add('tkc-phu--san');
            setTimeout(function () { URL.revokeObjectURL(u); }, 2000);
          };
          im.src = u;
        })
        .catch(function () {});
    }, daSanSang ? 450 : 0);
  }
  /* 05/10: TAI TRUOC moi bien the (lop anh co dinh + anh theo + muc thu vien cua o chon dang ve) khi trang ranh,
     bam doi lua chon la ve ngay, khong cho tai. Toi da 4 anh cung luc de khong chen anh san pham. */
  function taiTruoc() {
    /* 06/10: chi tai truoc lop SE HIEN neu khach doi them 1 lua chon (dieu kien hong <= 1) — mau nhieu lop (300+) khong tai het */
    var b = bangChon(), ds = [];
    (function di(lop, hongCha) {
      (lop || []).forEach(function (o) {
        var hong = hongCha + dsDk(o.dk).filter(function (d) { return !mot(d, b); }).length;
        if (hong > 1) return;
        if (o.loai === 'nhom') return di(o.con, hong);
        if (o.loai === 'anh' && o.tep && !o.chon && !anhDem[o.tep]) ds.push(o.tep);
        if (o.theo && o.theo.bang) for (var k in o.theo.bang) if (!anhDem[o.theo.bang[k]]) ds.push(o.theo.bang[k]);
        if (o.chon && !o.an && cfg.thuVien && cfg.thuVien.nhom[o.chon.thuVien]) cfg.thuVien.nhom[o.chon.thuVien].muc.forEach(function (m) { if (m.tep && !anhDem[m.tep]) ds.push(m.tep); });
      });
    })(cfg.xem.o, 0);
    ds = ds.slice(0, 120);
    var i = 0;
    function tiep() { if (i >= ds.length) return; var u = ds[i++]; (anhDem[u] ? Promise.resolve() : taiAnh(u)).then(tiep, tiep); }
    (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(function () { for (var k = 0; k < 4; k++) tiep(); }, { timeout: 2500 });
  }
  var henTruoc = 0;
  function taiTruocSau() { clearTimeout(henTruoc); henTruoc = setTimeout(taiTruoc, 600); }
  /* taiAnh ban 2: gan .v khi xong de ve dong bo */
  var taiAnhCu = taiAnh;
  taiAnh = function (url) { var p = taiAnhCu(url); if (!p.__gan) { p.__gan = 1; p.then(function (i) { p.v = i; }); } return p; };

  /* Dat canvas xem thu len anh san pham dau tien (Horizon: media-gallery). Khong tim thay -> dat trong khung form. */
  function datLenAnhSanPham() {
    var g = document.querySelector('media-gallery, .product-media-gallery, [class*="media-gallery"]');
    var anh = g && [].slice.call(g.querySelectorAll('img')).filter(function (i) { return i.getBoundingClientRect().width > 80; })[0];
    if (!anh) return null;
    var khung = anh.parentElement;
    if (getComputedStyle(khung).position === 'static') khung.style.position = 'relative';
    var phu = el('div', 'tkc-phu');
    var cv = el('canvas', 'tkc-phu__cv'); cv.setAttribute('aria-label', 'Live preview of your personalized ornament');
    phu.appendChild(cv); khung.appendChild(phu);
    /* 07/10 (user): khach DA ca nhan hoa thi bam anh san pham bi KHOA — khong mo lightbox anh goc cua theme, chi mo hop preview.
       Chua ca nhan hoa thi de theme phong to anh nhu thuong. Vua keo anh tai len thi khong tinh la bam. */
    /* Horizon bat click o document PHA CAPTURE (component.js on:click) -> phai nghe o WINDOW capture moi chan kip */
    window.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest || !t.closest('.tkc-phu') || !phu.contains(t)) return;
      /* 08/10: danh dau click da xu ly -> assets/tk-lightbox.js (cung nghe window capture) bo qua, du listener nao chay truoc */
      if (Date.now() - keoLuc < 450) { e.__tkcXuLy = 1; e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (!daSanSang || !coNoiDung(gt)) return;
      e.__tkcXuLy = 1; e.preventDefault(); e.stopImmediatePropagation(); moHop();
    }, true);
    return { cv: cv, phu: phu, toiDa: 1400 };
  }

  /* hop "Preview your personalization" */
  var hop = null;
  function moHop() {
    if (!hop) {
      hop = el('dialog', 'tkc-hop'); hop.setAttribute('aria-label', 'Preview your personalization');
      var dong = el('button', 'tkc-hop__dong'); dong.type = 'button'; dong.setAttribute('aria-label', 'Close'); dong.innerHTML = '&times;';
      /* 06/10 kieu pawfecthouse: tieu de + dong phu + anh + nut ADD TO CART ngay trong hop */
      var tde = el('p', 'tkc-hop__tde', 'Please check the preview carefully');
      var phu = el('p', 'tkc-hop__phu', 'Make sure the customization is correct to receive your item faster');
      var khung = el('div', 'tkc-hop__anh'); var cv = el('canvas', 'tkc-hop__cv'); khung.appendChild(cv);
      var mua = el('button', 'tkc-hop__mua'); mua.type = 'button';
      mua.setAttribute('data-lbx-region', 'atc-preview');   /* 09/10: kho dem click ATC theo vi tri (popup preview vs PDP) */
      mua.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.2 10.2a1 1 0 0 0 1 .8h8.6a1 1 0 0 0 1-.8L19.5 8H6.3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="9" cy="19" r="1.5" fill="currentColor"/><circle cx="16.5" cy="19" r="1.5" fill="currentColor"/><path d="M13 9.5v4M11 11.5h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><span>Add to cart</span>';
      mua.addEventListener('click', function () {
        var form = document.querySelector('.product-details form[action*="/cart/add"], form[action*="/cart/add"]');
        var nut = form && form.querySelector('[type=submit]');
        hop.close();
        if (!form || !nut) return;
        if (form.requestSubmit) form.requestSubmit(nut); else nut.click();
      });
      hop.appendChild(dong); hop.appendChild(tde); hop.appendChild(phu); hop.appendChild(khung); hop.appendChild(mua); document.body.appendChild(hop);
      dong.addEventListener('click', function () { hop.close(); });
      hop.addEventListener('click', function (e) { if (e.target === hop) hop.close(); });
      dich.push({ cv: cv, toiDa: 680, canHien: true });
    }
    hop.showModal(); veLai();
  }

  /* ── form ── */
  var oDom = {}, theoTruong = {};
  /* o hien khi dat dieu kien VA o dieu khien no cung dang hien (long nhau) */
  function hienO(f, b, sau) {
    if (!f.dk) return true;
    if (!datDk(f.dk, b)) return false;
    if ((sau || 0) > 8) return true;
    return oCha(f).every(function (k) { var cha = theoTruong[k]; return !cha || hienO(cha, b, (sau || 0) + 1); });
  }
  /* o "chonTruoc" (pawfect: so con) chua chon -> chi hien cac o chonTruoc, an het phan con lai */
  function chuaMoKhoa() { return cfg.o.some(function (f) { return f.chonTruoc && !gt[f.truong]; }); }
  function capNhatHien() {
    var b = bangChon(), khoa = chuaMoKhoa();
    cfg.o.forEach(function (f) { var d = oDom[f.truong]; if (!d) return; var h = (!khoa || f.chonTruoc) && hienO(f, b); d.hidden = !h; if (d.__gach) d.__gach.hidden = !h; });
  }
  var DAU_TICH = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8"/><path d="M4.6 8.2 7 10.5l4.4-4.6" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function dungO(f) {
    var hop = el('div', 'tkc-o tkc-o--' + f.kieu + (f.nhanPhu ? ' tkc-o--phu' : ''));
    var dau = el('div', 'tkc-nhan');
    dau.appendChild(el('span', null, f.nhan || f.truong));
    if (f.batBuoc && !f.nhanPhu) dau.appendChild(el('span', 'tkc-sao', '*'));
    hop.appendChild(dau);
    if (f.kieu === 'chon') {
      var hang = el('div', 'tkc-chon'); hang.setAttribute('role', 'radiogroup'); hang.setAttribute('aria-label', f.nhan || f.truong);
      var dsMuc = [];
      (function gom(id) { var n = cfg.thuVien.nhom[id]; if (!n) return; (n.muc || []).forEach(function (m) { dsMuc.push(m); }); for (var k in cfg.thuVien.nhom) if (cfg.thuVien.nhom[k].cha === id) gom(k); })(f.thuVien);
      var kieuHien = (cfg.thuVien.nhom[f.thuVien] || {}).hien;
      var dauNhan = dau.firstChild;
      if (kieuHien === 'ds') {                                   /* 06/10: o chon dang DROPDOWN (thang, nam, danh xung, don vi...) */
        var sel = el('select', 'tkc-ds'); sel.setAttribute('aria-label', f.nhan || f.truong);
        var o0 = el('option', null, 'Choose an Option'); o0.value = ''; o0.disabled = true; sel.appendChild(o0);
        dsMuc.forEach(function (m) { var op = el('option', null, m.ten); op.value = m.id; sel.appendChild(op); });
        sel.value = gt[f.truong] || f.macDinh || '';
        if (!sel.value) o0.selected = true;
        sel.addEventListener('change', function () { gt[f.truong] = sel.value; tuChon[f.truong] = 1; hop.classList.remove('loi'); goiYTheo(f.truong); capNhatHien(); veLai(); });
        hop.__dat = function (id) { sel.value = id; };
        hop.appendChild(sel);
        oDom[f.truong] = hop;
        hop.__loi = el('p', 'tkc-loi', 'This field is required'); hop.appendChild(hop.__loi);
        return hop;
      }
      var tenDang = el('span', 'tkc-ten-dang');                  /* "Choose Hair Color: Auburn" — o cham mau hien ten mau dang chon */
      if (kieuHien === 'mau' || /^tk2-mat-/.test(f.thuVien)) dau.appendChild(tenDang);   /* 03/11: o mau mat (anh doi mat) cung hien ten mau: "Choose Eye Color: Brown" */
      dsMuc.forEach(function (m) {
        var nut = el('button', 'tkc-muc'); nut.type = 'button'; nut.title = m.ten; nut.setAttribute('role', 'radio'); nut.setAttribute('aria-label', m.ten);
        if (!m.nho && m.mau) { nut.classList.add('tkc-muc--mau'); var cham = el('span', 'tkc-cham'); cham.style.background = m.mau; nut.appendChild(cham); }   /* o cham mau (da/toc) kieu pawfecthouse */
        else { var im = el('img'); im.src = m.nho; im.alt = ''; im.decoding = 'async'; im.width = 59; im.height = 59;   /* KHONG lazy: o con an luc dau (cho chon so con), mo ra phai co anh ngay */ nut.appendChild(im); }
        var tich = el('span', 'tkc-tich'); tich.innerHTML = DAU_TICH; nut.appendChild(tich);
        nut.addEventListener('click', function () { gt[f.truong] = m.id; tuChon[f.truong] = 1; hop.classList.remove('loi'); danhDau(); capNhatHien(); veLai(); });
        nut.__id = m.id; hang.appendChild(nut);
      });
      function danhDau() {
        var dang = f.chonTruoc ? gt[f.truong] : (gt[f.truong] || f.macDinh);
        Array.prototype.forEach.call(hang.children, function (n) { var on = n.__id === dang; n.classList.toggle('dang', on); n.setAttribute('aria-checked', on ? 'true' : 'false'); });
        var mm = dang && timMuc(dang); tenDang.textContent = mm ? ': ' + mm.ten : '';
      }
      hop.__dat = function () { danhDau(); };
      danhDau();
      hop.appendChild(hang);
    } else if (f.kieu === 'chu') {
      var dong = el('div', 'tkc-dong');
      var inp = el('input', 'tkc-nhap'); inp.type = 'text'; inp.maxLength = f.toiDa; inp.placeholder = f.goiY || ''; inp.autocomplete = 'off';
      if (f.nhapSo) inp.inputMode = 'decimal';
      inp.setAttribute('aria-label', f.nhan || f.truong);
      var dem = el('span', 'tkc-dem', '0/' + f.toiDa);
      if (typeof gt[f.truong] === 'string') { inp.value = gt[f.truong]; dem.textContent = inp.value.length + '/' + f.toiDa; }
      inp.addEventListener('input', function () {
        var v = inp.value.replace(CHO_PHEP, '');
        if (v !== inp.value) inp.value = v;
        gt[f.truong] = v; dem.textContent = v.length + '/' + f.toiDa; hop.classList.remove('loi'); goiYTheo(f.truong); veLai();
      });
      dong.appendChild(inp); dong.appendChild(dem); hop.appendChild(dong);
      if (f.goiYDuoi) hop.appendChild(el('p', 'tkc-goiy', f.goiYDuoi));
      hop.__inp = inp;
    } else if (f.kieu === 'tai') {
      /* 07/10: o tai anh kieu pawfecthouse (Teeinblue): Select Photo -> hop "Photo Editor" (% tai) -> hop chinh anh tren mockup
         (zoom/xoay/dich + Replace + Cancel/Apply) -> o hien anh nho + Edit / Replace. "Upload Guidelines" o dau o. */
      var laSieuAm = /ultrasound|sonogram|scan/i.test(f.nhan || '');
      var hd = el('button', 'tkc-hd'); hd.type = 'button';
      hd.innerHTML = 'Upload Guidelines <svg viewBox="0 0 24 24" width="10" height="10" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.6"/></svg>';
      hd.addEventListener('click', function () { moHuongDan(laSieuAm); });
      dau.appendChild(hd);
      var file = el('input'); file.type = 'file'; file.hidden = true; file.accept = 'image/jpeg,image/png,image/webp';
      var khungUp = el('div', 'tkc-up');
      var trong = el('div', 'tkc-up__trong');
      trong.appendChild(el('span', 'tkc-up__chu', laSieuAm ? 'Choose your ultrasound photo to upload' : 'Choose your photo to upload'));
      var nutChon = el('button', 'tkc-up__chon', 'Select Photo'); nutChon.type = 'button'; trong.appendChild(nutChon);
      var co = el('div', 'tkc-up__co');
      var hinhNho = el('span', 'tkc-up__hinh'); var thumb = el('img'); thumb.alt = 'Your uploaded photo'; hinhNho.appendChild(thumb);
      var nutXoa = el('button', 'tkc-up__xoa'); nutXoa.type = 'button'; nutXoa.setAttribute('aria-label', 'Remove photo'); nutXoa.innerHTML = '&times;'; hinhNho.appendChild(nutXoa);
      var nutSua = el('button', 'tkc-up__sua', 'Edit'); nutSua.type = 'button';
      var nutDoi = el('button', 'tkc-up__doi', 'Replace'); nutDoi.type = 'button';
      co.appendChild(hinhNho); co.appendChild(nutSua); co.appendChild(nutDoi);
      khungUp.appendChild(trong); khungUp.appendChild(co);
      var trang = el('p', 'tkc-trang'); trang.setAttribute('role', 'status');
      var hienUp = function () {
        var v = gt[f.truong], cO = !!(v && v.tep);
        trong.hidden = cO; co.hidden = !cO;
        if (cO) thumb.src = API + '/tai/' + v.tep;
      };
      thumb.addEventListener('error', function () {
        var v = gt[f.truong]; if (!v || !v.tep || thumb.src.indexOf(v.tep) < 0) return;
        delete gt[f.truong]; hienUp(); veLai();
        trang.textContent = 'Your previous photo is no longer available. Please upload it again.';
      });
      nutChon.addEventListener('click', function () { file.click(); });
      nutDoi.addEventListener('click', function () { file.click(); });
      nutSua.addEventListener('click', function () { moChinhAnh(f, trang, hienUp, file); });
      nutXoa.addEventListener('click', function () { delete gt[f.truong]; trang.textContent = ''; hienUp(); veLai(); });
      file.addEventListener('change', function () {
        var f0 = file.files && file.files[0]; file.value = ''; if (!f0) return;
        if (f0.size > 20 * 1024 * 1024) { trang.textContent = 'That photo is over 20 MB. Please choose a smaller one.'; return; }
        if (!/^image\/(jpe?g|png|webp)$/i.test(f0.type || '')) { trang.textContent = 'Please choose a JPG, PNG or WEBP photo.'; return; }
        var cho = moCho(); trang.textContent = '';
        guiAnh(f0, cho.dat, f.tach).then(function (j) {
          if (!j || !j.tep) throw new Error((j && j.chu) || 'We could not read that photo. Please try another one.');
          cho.dat(94);
          return taiAnh(API + '/tai/' + j.tep).then(function () { return j; });
        }).then(function (j) {
          cho.dat(100);
          gt[f.truong] = { tep: j.tep, zoom: 1, dx: 0, dy: 0, xoay: 0 }; hop.classList.remove('loi');
          /* 07/10: tach nen / cat mat — giu anh goc + moi khuon mat de khach doi trong hop chinh anh */
          if (j.tach && j.anhGoc) { var a0 = gt[f.truong]; a0.goc = j.anhGoc; a0.cac = j.cac || [j.tep]; a0.cat = j.tep; a0.tach = j.tach; a0.soMat = j.mat || 0; }
          var nhan = f.tach === 'mat' && j.tach === 'mat' && !j.mat ? 'We could not find a face in this photo, so we removed the background instead.'
            : f.tach && j.tachLoi ? 'We could not process this photo automatically, so we used it as is.' : '';
          hienUp(); veLai();
          setTimeout(function () { cho.dong(); moChinhAnh(f, trang, hienUp, file, j.thap, nhan); }, 300);
        }).catch(function (e) {
          cho.dong();
          trang.textContent = (e && e.message) || 'Upload failed. Check your connection and try again.';
        });
      });
      hienUp();
      hop.appendChild(khungUp); hop.appendChild(file); hop.appendChild(trang);
    }
    if (f.goiYDuoi && f.kieu !== 'chu') hop.appendChild(el('p', 'tkc-goiy', f.goiYDuoi));
    var loi = el('p', 'tkc-loi', 'This field is required'); hop.appendChild(loi); hop.__loi = loi;
    oDom[f.truong] = hop;
    return hop;
  }
  /* 06/10: goi y o chon tu o khac (chu cai dau cua ten -> monogram; thang sinh -> hoa) — chi khi khach chua tu chon */
  var tuChon = {};
  function goiYTheo(nguon) {
    cfg.o.forEach(function (f) {
      if (!f.goiYTu || f.goiYTu.tu !== nguon || tuChon[f.truong]) return;
      var muc = []; (function gom(id) { var n = cfg.thuVien.nhom[id]; if (n) (n.muc || []).forEach(function (m) { muc.push(m); }); })(f.thuVien);
      var can = null;
      if (f.goiYTu.kieu === 'chuDau') { var t = String(gt[nguon] || '').trim(); can = t ? t.charAt(0).toUpperCase() : null; }
      else { var mn = timMuc(gt[nguon]); can = mn ? String(mn.gia != null ? mn.gia : mn.ten) : null; }
      var hit = can && muc.filter(function (m) { return String(m.gia != null ? m.gia : m.ten) === can; })[0];
      if (!hit) return;
      gt[f.truong] = hit.id; var d = oDom[f.truong]; if (d && d.__dat) d.__dat(hit.id);
    });
  }

  /* ── 07/10 tai anh kieu pawfecthouse ── */
  var ICON = {
    nho: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M7.5 10.5h6"/></svg>',
    to: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M7.5 10.5h6M10.5 7.5v6"/></svg>',
    xtrai: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4v6h6"/><path d="M4.6 14a8 8 0 1 0 1.9-8.3L4 10"/></svg>',
    xphai: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 4v6h-6"/><path d="M19.4 14a8 8 0 1 1-1.9-8.3L20 10"/></svg>',
    trai: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12H4M10 6l-6 6 6 6"/></svg>',
    phai: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h16M14 6l6 6-6 6"/></svg>',
    len: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20V4M6 10l6-6 6 6"/></svg>',
    xuong: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v16M6 14l6 6 6-6"/></svg>',
    doi: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 18a4.5 4.5 0 0 1-.6-9A6 6 0 0 1 18 8.5a4 4 0 0 1-.5 9.5"/><path d="M12 12v8M9 15l3-3 3 3"/></svg>',
    anh: '<svg viewBox="0 0 64 64" aria-hidden="true"><rect x="6" y="12" width="44" height="40" rx="8"/><circle cx="20" cy="26" r="4"/><path d="M6 44l13-12 10 9 7-6 14 12"/><path d="M52 4l2.2 5.8L60 12l-5.8 2.2L52 20l-2.2-5.8L44 12l5.8-2.2z"/></svg>'
  };
  function hopMoi(cls, nhan) {
    var d = el('dialog', 'tkc-hop ' + cls); d.setAttribute('aria-label', nhan);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') e.stopPropagation(); });
    d.addEventListener('close', function () { setTimeout(function () { d.remove(); }, 0); });
    document.body.appendChild(d); return d;
  }
  function nutDong(d, xong) { var b = el('button', 'tkc-hop__dong'); b.type = 'button'; b.setAttribute('aria-label', 'Close'); b.innerHTML = '&times;'; b.addEventListener('click', xong); d.appendChild(b); return b; }
  /* gui anh bang XHR de co % tai len */
  function guiAnh(f0, tienDo, tach) {
    return new Promise(function (ok, hong) {
      var x = new XMLHttpRequest(); x.open('POST', API + '/tai' + (tach ? '?tach=' + tach : ''));
      x.setRequestHeader('Content-Type', f0.type || 'application/octet-stream');
      x.upload.onprogress = function (e) { if (e.lengthComputable) tienDo(Math.round(e.loaded / e.total * 85)); };
      x.onload = function () { var j = null; try { j = JSON.parse(x.responseText); } catch (e) {} if (j) ok(j); else hong(new Error('Upload failed. Please try again.')); };
      x.onerror = function () { hong(new Error('Upload failed. Check your connection and try again.')); };
      x.send(f0);
    });
  }
  /* hop "Photo Editor — Your photo is getting ready (x%)" */
  function moCho() {
    var d = hopMoi('tkc-cho', 'Preparing your photo');
    d.appendChild(el('p', 'tkc-cho__tde', 'Photo Editor'));
    var ic = el('div', 'tkc-cho__ic'); ic.innerHTML = ICON.anh; d.appendChild(ic);
    var chu = el('p', 'tkc-cho__chu', 'Your photo is getting ready (0%)'); d.appendChild(chu);
    var thanh = el('div', 'tkc-cho__thanh'); var day = el('span'); thanh.appendChild(day); d.appendChild(thanh);
    d.appendChild(el('p', 'tkc-cho__phu', 'Almost done — just a few seconds left'));
    d.addEventListener('cancel', function (e) { e.preventDefault(); });
    d.showModal();
    var hien = 0, muc = 0, t = setInterval(function () { if (hien < muc) { hien = Math.min(muc, hien + 3); chu.textContent = 'Your photo is getting ready (' + hien + '%)'; day.style.width = hien + '%'; } }, 40);
    return { dat: function (p) { muc = Math.max(muc, Math.min(100, p)); }, dong: function () { clearInterval(t); if (d.open) d.close(); } };
  }
  /* hop chinh anh tren mockup (giong tee-dialog-image-placement) */
  function moChinhAnh(f, trang, hienUp, file, thap, nhan) {
    var v = gt[f.truong]; if (!v || !v.tep) return;
    var truoc = JSON.parse(JSON.stringify(v));
    var d = hopMoi('tkc-chinh', 'Adjust your photo');
    var khung = el('div', 'tkc-chinh__khung'); var cv = el('canvas', 'tkc-chinh__cv'); cv.setAttribute('aria-label', 'Drag to move your photo');
    var xong = function (giu) {
      if (!giu) gt[f.truong] = truoc;
      var i = -1; dich.forEach(function (x, k) { if (x.cv === cv) i = k; }); if (i >= 0) dich.splice(i, 1);
      if (d.open) d.close(); hienUp(); veLai();
    };
    nutDong(d, function () { xong(false); });
    var vung = el('div', 'tkc-chinh__vung'); vung.hidden = true;
    ['tl', 'tr', 'bl', 'br'].forEach(function (g) { vung.appendChild(el('i', 'tkc-chinh__goc tkc-chinh__goc--' + g)); });
    khung.appendChild(cv); khung.appendChild(vung); d.appendChild(khung);
    var muc = { cv: cv, toiDa: 560, sauVe: function (t) {
      if (!t) return; var o = t.o; vung.hidden = false;
      vung.style.left = (o.x * 100) + '%'; vung.style.top = (o.y * 100) + '%'; vung.style.width = (o.w * 100) + '%'; vung.style.height = (o.h * 100) + '%';
      vung.style.transform = o.rot ? 'rotate(' + o.rot + 'deg)' : '';
    } };
    dich.push(muc);
    var kep = function (x) { return Math.max(-1, Math.min(1, Math.round(x * 100) / 100)); };
    var quay = function (a, g) { a.xoay = (((a.xoay || 0) + g + 180) % 360 + 360) % 360 - 180; };
    var luoi = el('div', 'tkc-chinh__luoi');
    [
      ['nho', 'Zoom out', function (a) { a.zoom = Math.max(1, Math.round(((a.zoom || 1) - 0.1) * 100) / 100); }],
      ['to', 'Zoom in', function (a) { a.zoom = Math.min(3, Math.round(((a.zoom || 1) + 0.1) * 100) / 100); }],
      ['xtrai', 'Rotate left', function (a) { quay(a, -90); }],
      ['xphai', 'Rotate right', function (a) { quay(a, 90); }],
      ['trai', 'Move left', function (a) { a.dx = kep((a.dx || 0) + 0.1); }],
      ['phai', 'Move right', function (a) { a.dx = kep((a.dx || 0) - 0.1); }],
      ['len', 'Move up', function (a) { a.dy = kep((a.dy || 0) + 0.1); }],
      ['xuong', 'Move down', function (a) { a.dy = kep((a.dy || 0) - 0.1); }]
    ].forEach(function (h) {
      var b = el('button', 'tkc-chinh__nut'); b.type = 'button'; b.setAttribute('aria-label', h[1]); b.title = h[1]; b.innerHTML = ICON[h[0]];
      b.addEventListener('click', function () { var a = gt[f.truong]; if (!a) return; h[2](a); veLai(); });
      luoi.appendChild(b);
    });
    d.appendChild(luoi);
    /* 07/10: anh da tach nen / cat mat -> cho tat de dung anh goc; nhieu khuon mat -> chon mat */
    if (v.goc && v.cat) {
      var hangT = el('label', 'tkc-chinh__tach');
      var oT = el('input'); oT.type = 'checkbox'; oT.checked = v.tep !== v.goc;
      hangT.appendChild(oT); hangT.appendChild(el('span', null, v.tach === 'mat' ? 'Face cutout' : 'Remove background'));
      var dsMat = null;
      var datTep = function (t) { var a = gt[f.truong]; if (!a) return; a.tep = t; a.zoom = 1; a.dx = 0; a.dy = 0; hienUp(); veLai(); };
      oT.addEventListener('change', function () { datTep(oT.checked ? gt[f.truong].cat : gt[f.truong].goc); if (dsMat) dsMat.hidden = !oT.checked; });
      d.appendChild(hangT);
      if (v.cac && v.cac.length > 1) {
        dsMat = el('div', 'tkc-chinh__mat'); dsMat.appendChild(el('span', null, 'Choose a face:')); dsMat.hidden = !oT.checked;
        v.cac.forEach(function (t) {
          var b = el('button', 'tkc-chinh__mat-nut' + (t === v.cat ? ' dang' : '')); b.type = 'button'; b.setAttribute('aria-label', 'Use this face');
          var im = el('img'); im.src = API + '/tai/' + t; im.alt = ''; b.appendChild(im);
          b.addEventListener('click', function () {
            [].forEach.call(dsMat.querySelectorAll('.tkc-chinh__mat-nut'), function (x) { x.classList.toggle('dang', x === b); });
            gt[f.truong].cat = t; datTep(t);
          });
          dsMat.appendChild(b);
        });
        d.appendChild(dsMat);
      }
    }
    if (nhan) d.appendChild(el('p', 'tkc-chinh__nhan', nhan));
    var doi = el('button', 'tkc-chinh__doi'); doi.type = 'button'; doi.innerHTML = ICON.doi + '<span>Replace Photo</span>';
    doi.addEventListener('click', function () { xong(false); file.click(); });
    d.appendChild(doi);
    d.appendChild(el('p', 'tkc-chinh__goiy', 'Tip: drag the photo in the preview to move it.'));
    var chan = el('div', 'tkc-chinh__chan');
    var huy = el('button', 'tkc-chinh__huy', 'Cancel'); huy.type = 'button';
    var ap = el('button', 'tkc-chinh__ap', 'Apply'); ap.type = 'button';
    huy.addEventListener('click', function () { xong(false); });
    ap.addEventListener('click', function () {
      xong(true);
      trang.textContent = thap ? 'Your photo is a little small (under 1000 px), so the print may look soft. A larger photo is recommended.' : '';
    });
    chan.appendChild(huy); chan.appendChild(ap); d.appendChild(chan);
    d.addEventListener('cancel', function (e) { e.preventDefault(); xong(false); });
    /* keo anh: bat ky dau tren mockup */
    var dang = null;
    cv.addEventListener('pointerdown', function (e) {
      var a = gt[f.truong], t = muc.tai; if (!a || !t) return;
      var r = cv.getBoundingClientRect();
      dang = { x: e.clientX, y: e.clientY, dx: a.dx || 0, dy: a.dy || 0, a: a, rong: t.o.w * r.width, cao: t.o.h * r.height };
      cv.setPointerCapture(e.pointerId); e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (!dang) return;
      var z = dang.a.zoom || 1, tx = Math.max(1, dang.rong * Math.max(0.15, z - 1) / 2), ty = Math.max(1, dang.cao * Math.max(0.15, z - 1) / 2);
      dang.a.dx = kep(dang.dx - (e.clientX - dang.x) / tx); dang.a.dy = kep(dang.dy - (e.clientY - dang.y) / ty);
      veLai();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { cv.addEventListener(t, function () { dang = null; }); });
    d.showModal();
    veLai();
  }
  /* "Upload Guidelines" */
  function moHuongDan(laSieuAm) {
    var d = hopMoi('tkc-hd-hop', 'Photo upload guidelines');
    nutDong(d, function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.appendChild(el('p', 'tkc-hd-hop__tde', 'Photo Upload Guidelines'));
    var ol = el('ol', 'tkc-hd-hop__ds');
    var li = function (t) { var x = el('li'); x.appendChild(el('span', null, t)); ol.appendChild(x); return x; };
    li('Upload or replace your ' + (laSieuAm ? 'ultrasound photo' : 'photo') + ' anytime.');
    var l2 = li('Adjust it with the controls under the preview.');
    var ic = el('div', 'tkc-hd-hop__ic');
    ['xtrai', 'xphai', 'nho', 'to', 'len', 'xuong', 'trai', 'phai'].forEach(function (k) { var sp = el('span'); sp.innerHTML = ICON[k]; ic.appendChild(sp); });
    l2.appendChild(ic);
    var l3 = li(laSieuAm ? 'Use a clear, sharp photo of your scan, taken straight-on with no glare.' : 'Use a clear, sharp, well-lit photo with the face easy to see.');
    var cap = el('div', 'tkc-hd-hop__cap'), goc = 'https://totkind.com/cdn/shop/files/tk-up-' + (laSieuAm ? 'ul' : 'ph') + '-';
    [['good', 'Good', 'tot', '✓'], ['bad', 'Not Good', 'xau', '✕']].forEach(function (x) {
      var fg = el('figure'); var im = el('img'); im.src = goc + x[0] + '.jpg?width=420'; im.alt = x[1] + ' example'; im.loading = 'lazy'; fg.appendChild(im);
      var fc = el('figcaption', 'tkc-hd-hop__' + x[2]); var b = el('b', null, x[3]); b.setAttribute('aria-hidden', 'true'); fc.appendChild(b); fc.appendChild(el('span', null, x[1]));
      fg.appendChild(fc); cap.appendChild(fg);
    });
    l3.appendChild(cap);
    li('What you see in the preview is exactly what we print.');
    d.appendChild(ol);
    d.showModal();
  }

  /* keo anh tai len tren anh xem thu chinh */
  var keoLuc = 0;   /* luc vua keo xong anh tai len (de bo qua cu click ngay sau do) */
  function ganKeo(cv) {
    var dang = null;
    cv.addEventListener('pointerdown', function (e) {
      if (!khungTai) return;
      var r = cv.getBoundingClientRect(), k = cv.width / r.width, x = (e.clientX - r.left) * k, y = (e.clientY - r.top) * k, o = khungTai.o;
      if (x < o.x * khungTai.W || x > (o.x + o.w) * khungTai.W || y < o.y * khungTai.H || y > (o.y + o.h) * khungTai.H) return;
      var v = gt[truong(o)]; if (!v) return;
      dang = { x: e.clientX, y: e.clientY, dx: v.dx, dy: v.dy, v: v, rong: o.w * r.width, cao: o.h * r.height };
      cv.setPointerCapture(e.pointerId); e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (!dang) return;
      var z = dang.v.zoom || 1, tx = Math.max(0.0001, dang.rong * (z - 1) / 2 + dang.rong * 0.0001), ty = Math.max(0.0001, dang.cao * (z - 1) / 2 + dang.cao * 0.0001);
      dang.v.dx = Math.max(-1, Math.min(1, dang.dx - (e.clientX - dang.x) / tx));
      dang.v.dy = Math.max(-1, Math.min(1, dang.dy - (e.clientY - dang.y) / ty));
      if (Math.abs(e.clientX - dang.x) + Math.abs(e.clientY - dang.y) > 6) dang.di = true;
      veLai();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { cv.addEventListener(t, function () { if (dang && dang.di) keoLuc = Date.now(); dang = null; }); });
  }

  /* ── Add to cart ── */
  function maMoi() { var c = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789', s = '', a = new Uint32Array(12); crypto.getRandomValues(a); for (var i = 0; i < 12; i++) s += c[a[i] % c.length]; return s; }
  function kiem() {
    var b = bangChon(), dau = null, khoa = chuaMoKhoa();
    cfg.o.forEach(function (f) {
      var d = oDom[f.truong]; if (!d || !hienO(f, b) || !f.batBuoc) return;
      if (khoa && !f.chonTruoc) return;                       /* o con dang an vi chua chon so con */
      var v = gt[f.truong];
      if (f.chonTruoc && !v) { d.classList.add('loi'); if (!dau) dau = d; return; }
      var thieu = f.kieu === 'chu' ? !(typeof v === 'string' && (v.trim() || (f.choTrong && v.length))) : f.kieu === 'tai' ? !(v && v.tep)
        : (f.kieu === 'chon' && f.batBuocChon && !f.macDinh && !v);            /* o chon khong co mac dinh: khach phai tu chon */
      var sai = !thieu && f.kieu === 'chu' && f.kiemTra && f.kiemTra.re && typeof v === 'string' && v.trim() && !new RegExp(f.kiemTra.re).test(v.trim());
      if (d.__loi) d.__loi.textContent = sai ? (f.kiemTra.loi || 'Please check this field') : 'This field is required';
      d.classList.toggle('loi', thieu || sai);
      if ((thieu || sai) && !dau) dau = d;
    });
    /* luat ca mau: ngay sinh phai co that, khong o tuong lai */
    (cfg.luat || []).forEach(function (l) {
      if (l.loai !== 'ngay' || dau) return;
      var so = function (k) { var m = timMuc(gt[k]); return m ? Number(m.gia != null ? m.gia : m.ten) : NaN; };
      var t = so(l.thang), dd = so(l.ngay), n = so(l.nam); if (isNaN(t) || isNaN(dd) || isNaN(n)) return;
      var dt = new Date(Date.UTC(n, t - 1, dd));
      var hong = !(dt.getUTCMonth() === t - 1 && dt.getUTCDate() === dd) || (l.khongTuongLai && dt.getTime() > Date.now() + 86400e3);
      var d = oDom[l.ngay]; if (!hong || !d) return;
      if (d.__loi) d.__loi.textContent = l.loi || 'Please choose a real date'; d.classList.add('loi'); dau = d;
    });
    if (dau) { dau.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (dau.__inp) dau.__inp.focus({ preventScroll: true }); }
    return !dau;
  }
  /* thuoc tinh dong hang (theo thu tu) cho 1 ma thiet ke — dung chung cho them gio (PDP) va sua trong drawer */
  /* 07/10: MOI thuoc tinh deu bat dau "_" -> checkout/email khong hien (checkout chi ghi variant "Acrylic Ornament / As Preview / As Described"
     nhu pawfecthouse); cart drawer + admin van doc duoc. */
  function thuocTinh(ma) {
    var ra = [], b = bangChon();
    var them = function (ten, gia, hien) { ra.push([hien || ten.charAt(0) === '_' ? ten : '_' + ten, gia]); };   /* hien = giu ten khong '_' (link Preview hien o checkout, user 07/10) */
    cfg.o.forEach(function (f) {
      if (!hienO(f, b)) return;
      var v = gt[f.truong], ten = f.nhanPhu && theoTruong[f.dk && f.dk.lop] ? (theoTruong[f.dk.lop].nhan + ' - ' + f.nhan) : (f.nhan || f.truong);
      if (f.kieu === 'chu' && typeof v === 'string' && v.trim()) them(ten, v.trim());
      else if (f.kieu === 'chon') { var m = timMuc(v || f.macDinh); if (m) them(ten, m.ten); }
      else if (f.kieu === 'tai' && v && v.tep) them(ten || 'Photo', 'Uploaded');
    });
    var tat = cfg.xemMay === 'tat';   /* 16/10: tat -> anh tat that + file in Dreamship mat truoc (lib/tat.js) */
    them('Preview', API + (tat ? '/vt/' : '/v/') + ma + '.jpg', true);
    them('_Production', API + (tat ? '/int/' : '/in/') + ma);
    return ra;
  }
  function goiDat(ma) { return JSON.stringify({ ma: ma, mau: cfg.key, handle: HANDLE, gt: gt }); }
  /* drawer: CHO may chu ghi xong (anh preview phai mo duoc ngay) */
  function dangKy(ma) {
    return fetch(API + '/dat', { method: 'POST', body: goiDat(ma), headers: { 'Content-Type': 'text/plain' } })
      .then(function (r) { if (!r.ok) return r.text().then(function (t) { throw new Error(t || ('save ' + r.status)); }); return r; });
  }
  function ganVaoForm(form) {
    Array.prototype.forEach.call(document.querySelectorAll('input[data-tkc="1"]'), function (i) { i.remove(); });
    var ma = maMoi();
    thuocTinh(ma).forEach(function (p) { var i = el('input'); i.type = 'hidden'; i.name = 'properties[' + p[0] + ']'; i.value = p[1]; i.setAttribute('data-tkc', '1'); form.appendChild(i); });
    var goi = goiDat(ma);
    try { if (!(navigator.sendBeacon && navigator.sendBeacon(API + '/dat', new Blob([goi], { type: 'text/plain' })))) throw 0; }
    catch (e) { fetch(API + '/dat', { method: 'POST', body: goi, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {}); }
    luuLichSu();
  }
  /* 08/10 user: BO hop nhac do 'Please complete your personalization' tren nut mua — kiem() da cuon toi o thieu + to do o do la du.
     Giu ham de xoa hop con sot (trang mo tu ban cu). */
  function baoThieu() {
    var cu = document.querySelector('.tkc-chua-xong'); if (cu) cu.remove();
  }
  function ganNutMua() {
    /* bat submit o WINDOW pha capture: Horizon nghe submit tren document (capture, dang ky truoc minh) roi fetch(FormData(form)) ngay -> nghe o document la qua muon */
    window.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (!kiem()) { e.preventDefault(); e.stopImmediatePropagation(); baoThieu(form); return; }
      baoThieu(form, true);
      ganVaoForm(form);
    }, true);
    /* 08/10: bao cho tk-upsell.js (mon di kem) dang ky SAU minh -> no chay sau khi form da kiem + gan thuoc tinh ca nhan hoa */
    window.__tkcMua = 1; document.dispatchEvent(new Event('tkc:mua'));
  }

  /* 06/10: nut DINH duoi man hinh "Preview your personalization" (hien khi nut goc da troi khoi man hinh, an khi toi footer)
     + nut mui ten len dau trang — y pawfecthouse */
  /* 07/10 (user, hoc pawfecthouse): MOBILE — khach dang dien form ma anh san pham (preview) da cuon khuat
     -> hien KHUNG PREVIEW NOI dinh ngay duoi header, ve lai theo tung thay doi; co nut +/- phong to va X dong
     (dong roi chi hien lai khi khach cuon len thay anh chinh roi xuong lai). */
  function ganXemNoi() {
    if (!canvasChinh) return;
    var noi = el('div', 'tkc-noi'); noi.hidden = true;
    var khung = el('div', 'tkc-noi__khung'); var cv = el('canvas', 'tkc-noi__cv'); cv.setAttribute('aria-label', 'Live preview of your personalization');
    khung.appendChild(cv); noi.appendChild(khung);
    var dong = el('button', 'tkc-noi__dong'); dong.type = 'button'; dong.setAttribute('aria-label', 'Hide preview'); dong.innerHTML = '&times;';
    var zoom = el('div', 'tkc-noi__zoom');
    var to = el('button', null, '+'); to.type = 'button'; to.setAttribute('aria-label', 'Zoom in');
    var nho = el('button', null, '−'); nho.type = 'button'; nho.setAttribute('aria-label', 'Zoom out');
    zoom.appendChild(to); zoom.appendChild(nho);
    noi.appendChild(dong); noi.appendChild(zoom);
    document.body.appendChild(noi);
    var muc = { cv: cv, toiDa: 2400, canHien: true }; cv.__phong = 1.25;   /* 03/11: do net theo muc zoom (__phong = 1,25 x tile), toi da 2400px */
    var henVeZoom = 0, veTheoZoom = function () { var p = Math.max(1.25, 1.25 * tile); if (Math.abs(p - cv.__phong) < 0.2) return; cv.__phong = p; clearTimeout(henVeZoom); henVeZoom = setTimeout(veLai, 220); };
    dich.push(muc);
    var tile = 1, daDong = false;
    /* 03/11 (user, hoc pawfecthouse = @panzoom/panzoom 4.6.1): 5 NAC (moi nac x e^0.3 ~ x1.35, toi da x4), 2 NGON TAY pinch zoom quanh
       diem giua 2 ngon, KEO khi dang phong to (khong lo mep), CHAM DUP x2.2 tai diem cham / ve x1; nut - khi <= 1.15 thi ve x1 */
    var TOI_DA = 4, BUOC = Math.exp(0.3), px = 0, py = 0, ngon = {}, cu = null, chamCuoi = 0, chamXY = null;
    /* 03/11 (user: iPhone bam + van mo): Safari giu anh lop o co CU roi keo gian khi scale() bang CSS -> luc dang thao tac dung scale cho muot,
       dung tay ~0,26s thi "CHOT": dat KICH THUOC THAT cho canvas (rong = khung x tile) + chi dich vi tri -> Safari ve lai net theo canvas to. */
    var dangChot = false, henChotT = 0;
    var datTf = function () {
      var r = khung.getBoundingClientRect(), mx = r.width * (tile - 1) / 2, my = r.height * (tile - 1) / 2;
      px = Math.max(-mx, Math.min(mx, px)); py = Math.max(-my, Math.min(my, py));
      if (dangChot) { cv.style.width = r.width * tile + 'px'; cv.style.height = r.height * tile + 'px'; cv.style.maxWidth = 'none'; cv.style.transform = 'translate(' + (px - mx) + 'px,' + (py - my) + 'px)'; }
      else { cv.style.width = cv.style.height = cv.style.maxWidth = ''; cv.style.transform = 'translate(' + px + 'px,' + py + 'px) scale(' + tile + ')'; }
      khung.classList.toggle('tkc-noi__khung--keo', tile > 1);
    };
    var doiKieu = function (chot) { if (dangChot === chot) return; var tr = cv.style.transition; cv.style.transition = 'none'; dangChot = chot; datTf(); void cv.offsetWidth; cv.style.transition = tr; };
    var boChot = function () { clearTimeout(henChotT); doiKieu(false); };
    var ve = function () { datTf(); clearTimeout(henChotT); henChotT = setTimeout(function () { if (!Object.keys(ngon).length) doiKieu(tile > 1); }, 260); };
    /* phong to quanh diem (cx, cy) tren man hinh: diem anh duoi ngon tay dung yen */
    var datTile = function (t, cx, cy) {
      boChot(); var t2 = Math.max(1, Math.min(TOI_DA, t)), r = khung.getBoundingClientRect();
      if (cx != null) { var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2); px = ox - (ox - px) * t2 / tile; py = oy - (oy - py) * t2 / tile; }
      tile = t2; if (tile === 1) { px = 0; py = 0; } ve(); veTheoZoom();
    };
    var dsNgon = function () { return Object.keys(ngon).map(function (k) { return ngon[k]; }); };
    var batDauCu = function () {
      var d = dsNgon();
      if (d.length >= 2) { var a = d[0], b = d[1]; cu = { kieu: 'pinch', kc: Math.hypot(a.x - b.x, a.y - b.y) || 1, t: tile, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2, px: px, py: py }; }
      else if (d.length === 1 && tile > 1) cu = { kieu: 'keo', x: d[0].x, y: d[0].y, px: px, py: py };
      else cu = null;
    };
    khung.addEventListener('pointerdown', function (e) {
      ngon[e.pointerId] = { x: e.clientX, y: e.clientY, x0: e.clientX, y0: e.clientY };
      try { khung.setPointerCapture(e.pointerId); } catch (er) {}
      boChot(); cv.style.transition = 'none'; batDauCu(); e.preventDefault();
    });
    khung.addEventListener('pointermove', function (e) {
      var n = ngon[e.pointerId]; if (!n) return; n.x = e.clientX; n.y = e.clientY;
      if (!cu) return; e.preventDefault();
      if (cu.kieu === 'pinch') { var d = dsNgon(); if (d.length < 2) return; var a = d[0], b = d[1];
        var t2 = Math.max(1, Math.min(TOI_DA, cu.t * Math.hypot(a.x - b.x, a.y - b.y) / cu.kc)), mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2, r = khung.getBoundingClientRect();
        var ox = cu.mx - (r.left + r.width / 2), oy = cu.my - (r.top + r.height / 2);
        tile = t2; px = ox - (ox - cu.px) * t2 / cu.t + (mx - cu.mx); py = oy - (oy - cu.py) * t2 / cu.t + (my - cu.my); if (tile === 1) { px = 0; py = 0; } ve(); }
      else { px = cu.px + (e.clientX - cu.x); py = cu.py + (e.clientY - cu.y); ve(); }
    });
    var tha = function (e) {
      var n = ngon[e.pointerId]; if (!n) return; delete ngon[e.pointerId];
      var laCham = e.type === 'pointerup' && Math.hypot(n.x - n.x0, n.y - n.y0) < 10 && !Object.keys(ngon).length && (!cu || cu.kieu !== 'pinch');
      batDauCu(); if (!Object.keys(ngon).length) { cv.style.transition = ''; veTheoZoom(); ve(); }
      if (laCham) { var bay = Date.now(); if (bay - chamCuoi < 300 && bay - chamCuoi > 50) { if (tile <= 1.05) datTile(2.2, e.clientX, e.clientY); else datTile(1); chamCuoi = 0; } else chamCuoi = bay; }
    };
    khung.addEventListener('pointerup', tha); khung.addEventListener('pointercancel', tha);
    to.addEventListener('click', function () { datTile(tile * BUOC); });
    nho.addEventListener('click', function () { if (tile / BUOC <= 1.15) datTile(1); else datTile(tile / BUOC); });
    dong.addEventListener('click', function () { daDong = true; noi.hidden = true; });
    var header = function () { var h = document.querySelector('header-component, #header-component, .header-section, header'); var r = h && h.getBoundingClientRect(); return r && r.bottom > 0 ? Math.round(r.bottom) : 0; };
    var capNhat = function () {
      var mobile = window.innerWidth < 750;
      var rA = canvasChinh.getBoundingClientRect(), rF = goc.getBoundingClientRect(), top = header();
      var anhKhuat = rA.bottom < top + 40;
      if (!anhKhuat) daDong = false;                                   /* thay lai anh chinh -> cho phep hien lai */
      var trongForm = rF.top < window.innerHeight * 0.6 && rF.bottom > top + 120;
      /* 08/10 (user): chi hien khi khach DA THAO TAC it nhat 1 o — tu chon 1 lua chon, go chu, hoac tai anh */
      var daNhap = Object.keys(tuChon).length > 0 || Object.keys(gt).some(function (k) { var v = gt[k]; return (typeof v === 'string' && v.trim() !== '' && v !== macDinh[k]) || (v && v.tep); });
      var hien = mobile && daNhap && anhKhuat && trongForm && !daDong && !document.querySelector('dialog[open]');
      /* 08/10 user: khung preview noi THAP DI dung bang chieu cao header dinh (CSS: --tkc-dau) */
      if (hien) { noi.style.top = top + 'px'; noi.style.setProperty('--tkc-dau', top + 'px'); if (noi.hidden) { noi.hidden = false; veLai(); } }
      else if (!noi.hidden) { noi.hidden = true; datTile(1); }
    };
    window.addEventListener('scroll', capNhat, { passive: true });
    window.addEventListener('resize', capNhat);
    goc.addEventListener('focusin', function () { setTimeout(capNhat, 350); });
    setInterval(capNhat, 700);
    capNhat();
  }
  var TAT_DINH = false;  /* 08/10 user: thanh Preview dinh GIU (chi tat Sticky ATC cua theme = enable_sticky_add_to_cart) */
  function ganThanhDinh(nutGoc) {
    var thanh = el('div', 'tkc-dinh'); thanh.hidden = true;
    var nut = el('button', 'tkc-dinh__nut', 'Preview your personalization'); nut.type = 'button';
    nut.addEventListener('click', moHop);
    var len = el('button', 'tkc-len'); len.type = 'button'; len.setAttribute('aria-label', 'Back to top'); len.hidden = true;
    len.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M5.5 11.5 12 5l6.5 6.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    len.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    thanh.appendChild(nut); document.body.appendChild(thanh); document.body.appendChild(len);
    var chan = document.querySelector('.shopify-section-group-footer-group, footer');
    var capNhat = function () {
      var r = nutGoc.getBoundingClientRect(), vh = window.innerHeight;
      var nutHien = r.height > 0 && r.bottom > 0 && r.top < vh;                       /* nut goc dang trong man hinh */
      var chanHien = !!chan && chan.getBoundingClientRect().top < vh - 40;           /* da cuon toi footer */
      /* 08/10 user: TAT sticky ATC tren PDP -> thanh nut khong bao gio hien; giu nut mui ten len dau trang */
      /* 08/10 user: mo CART DRAWER tren desktop van giu nut (CSS dat nut goc trai); mobile drawer phu kin -> CSS tu an */
      var dinh = TAT_DINH ? false : (!nutHien && !chanHien && !document.querySelector('dialog[open]:not(.color-custom-drawer)'));
      thanh.hidden = !dinh; document.body.classList.toggle('tkc-co-dinh', dinh);
      len.hidden = window.scrollY < 500 || chanHien;
    };
    window.addEventListener('scroll', capNhat, { passive: true });
    window.addEventListener('resize', capNhat);
    var lan = 0, hen = setInterval(function () { capNhat(); if (++lan > 20) clearInterval(hen); }, 500);   /* anh/gallery tai xong lam doi bo cuc */
    capNhat();
  }
  /* ── 06/10 LICH SU ca nhan hoa theo san pham (kieu Teeinblue): localStorage 'tkc-ls' = [{h, gt, t}], giu 12 san pham, 90 ngay ── */
  var KHOA_LS = 'tkc-ls', daSanSang = false, henLs = 0, macDinh = {};
  function docLs() { try { var a = JSON.parse(localStorage.getItem(KHOA_LS) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function coNoiDung(g) { return Object.keys(g || {}).some(function (k) { var v = g[k]; return (typeof v === 'string' && v.trim() && v !== macDinh[k]) || (v && v.tep); }); }
  function luuLichSu() {
    if (CHE !== 'pdp' || !HANDLE || !coNoiDung(gt)) return;
    try {
      var a = docLs().filter(function (x) { return x && x.h !== HANDLE; });
      a.push({ h: HANDLE, gt: JSON.parse(JSON.stringify(gt)), t: Date.now() });
      localStorage.setItem(KHOA_LS, JSON.stringify(a.slice(-12)));
    } catch (e) {}
  }
  function luuLichSuSau() { clearTimeout(henLs); henLs = setTimeout(luuLichSu, 500); }
  function hoiKhoiPhuc(cu) {
    var d = el('dialog', 'tkc-hop tkc-hoi'); d.setAttribute('aria-label', 'Restore your previous personalization');
    var dong = el('button', 'tkc-hop__dong'); dong.type = 'button'; dong.setAttribute('aria-label', 'Close'); dong.innerHTML = '&times;';
    d.appendChild(dong);
    d.appendChild(el('p', 'tkc-hop__tde', 'Welcome back!'));
    d.appendChild(el('p', 'tkc-hop__phu', 'We found your previous personalization for this design. Would you like to auto-fill it?'));
    var hang = el('div', 'tkc-hoi__nut');
    var co = el('button', 'tkc-hop__mua', 'Yes, please'); co.type = 'button';
    var khong = el('button', 'tkc-hoi__khong', 'No, start fresh'); khong.type = 'button';
    hang.appendChild(co); hang.appendChild(khong); d.appendChild(hang);
    document.body.appendChild(d);
    var xong = function () { d.close(); setTimeout(function () { d.remove(); }, 0); };
    dong.addEventListener('click', xong); khong.addEventListener('click', xong);
    d.addEventListener('click', function (e) { if (e.target === d) xong(); });
    co.addEventListener('click', function () { apGt(cu.gt); xong(); });
    d.showModal();
  }
  /* nap bo gia tri vao form dang co: dung lai cac o (form tu doc gt) */
  function apGt(g) {
    Object.keys(g || {}).forEach(function (k) { if (theoTruong[k]) { gt[k] = g[k]; tuChon[k] = 1; } });
    dungForm(); capNhatHien(); veLai();
  }
  var formEl = null;
  function dungForm() {
    oDom = {};
    var form = el('div', 'tkc-form');
    cfg.o.forEach(function (f) {
      var o = dungO(f);
      /* 16/10 (user): BO dong gach dut '-----' truoc o (xau, khong de lam gi) o MOI form ca nhan hoa */
      form.appendChild(o);
    });
    if (CHE === 'pdp') form.appendChild(el('p', 'tkc-chu-cuoi', 'Live preview available: You can scroll up anytime to check it'));
    if (formEl && formEl.parentNode) formEl.parentNode.replaceChild(form, formEl); else goc.appendChild(form);
    formEl = form;
  }
  function batDau() {
    /* 05/10: uu tien cau hinh nhung san trong trang (metafield tkc.cfg), khong co moi goi may chu */
    var nhung = opts.cfg || null;
    if (!nhung && CHE === 'pdp') { try { var th = document.getElementById('tkc-cfg'); if (th) nhung = JSON.parse(th.textContent); } catch (e) { nhung = null; } }
    return (nhung && nhung.xem ? Promise.resolve(nhung) : fetch(API + '/sp/' + encodeURIComponent(HANDLE) + '.json').then(function (r) { if (r.status !== 200) throw 0; return r.json(); })).then(function (c) {
      cfg = c;
      cfg.o.forEach(function (f) {
        theoTruong[f.truong] = f;
        if (f.kieu === 'chon' && f.macDinh && !f.chonTruoc) gt[f.truong] = f.macDinh;
        if (f.kieu === 'chu' && typeof f.macDinh === 'string' && f.macDinh) gt[f.truong] = f.macDinh;   /* 16/10: o chu dien san (nam tat) */
      });
      macDinh = JSON.parse(JSON.stringify(gt));
      if (opts.gt) Object.keys(opts.gt).forEach(function (k) { if (theoTruong[k]) { gt[k] = opts.gt[k]; tuChon[k] = 1; } });
      goc.innerHTML = '';
      if (CHE === 'pdp') {
        dungForm();
        /* xem thu: tren anh san pham; khong co gallery thi dat trong form */
        var anhSp = datLenAnhSanPham();
        if (anhSp) { dich.push(anhSp); canvasChinh = anhSp.cv; }
        else {
          var xem = el('div', 'tkc-xem'); var cv = el('canvas', 'tkc-canvas'); xem.appendChild(cv); goc.insertBefore(xem, formEl);
          dich.push({ cv: cv, toiDa: 560 }); canvasChinh = cv;
        }
        /* 07/10 (user): anh san pham CHI XEM — khong keo anh tai len tren do nua; chinh vi tri trong hop chinh anh (Edit) */
        var nutXem = el('button', 'tkc-nut-xem', 'Preview your personalization'); nutXem.type = 'button';
        nutXem.addEventListener('click', moHop);
        /* 07/10 (user): nut Preview dat NGAY TREN nut Add to cart (sau khoi Bundle & Save), khong o cuoi form */
        var khoiMua = document.querySelector('.product-details .buy-buttons-block');
        if (khoiMua && khoiMua.parentNode) { nutXem.classList.add('tkc-nut-xem--tren-atc'); khoiMua.parentNode.insertBefore(nutXem, khoiMua); }
        else goc.appendChild(nutXem);
        ganThanhDinh(nutXem);
        ganXemNoi();
        ganNutMua();
      } else if (CHE === 'tat') {
        /* 16/10 che 'tat' (popup tat cross-sell, tk-upsell.js): chi form — anh xem thu do popup tu ve */
        dungForm();
      } else {
        /* che 'sua' (drawer): canvas o tren, form o duoi, trong chinh goc */
        var xem2 = el('div', 'tkc-xem tkc-xem--sua'); var cv2 = el('canvas', 'tkc-canvas'); xem2.appendChild(cv2); goc.appendChild(xem2);
        dich.push({ cv: cv2, toiDa: 520 }); canvasChinh = cv2; ganKeo(cv2);
        dungForm();
      }
      goc.hidden = false;
      capNhatHien(); veLai(); if (!cfg.xemMay) taiTruoc();
      daSanSang = true;
      var hen = 0; window.addEventListener('resize', function () { clearTimeout(hen); hen = setTimeout(veLai, 150); });
      if (CHE === 'pdp' && !opts.gt) {
        var cu = docLs().filter(function (x) { return x && x.h === HANDLE && Date.now() - (x.t || 0) < 90 * 864e5; })[0];
        if (cu && coNoiDung(cu.gt)) setTimeout(function () { hoiKhoiPhuc(cu); }, 600);
      }
      if (opts.sanSang) opts.sanSang();
    }).catch(function (e) { goc.hidden = true; if (opts.loi) opts.loi(e); });
  }
  batDau();
  return {
    kiem: kiem, thuocTinh: thuocTinh, dangKy: dangKy, maMoi: maMoi,
    gt: function () { return gt; }, cfg: function () { return cfg; }, ve: veLai,
  };
  }
  TKC.anhDem = {}; TKC.fontDa = {};
  window.TKC = TKC;

  /* 07/10 (user): moi hop .tkc-hop dang mo (Edit, Preview, Guidelines, Photo Editor, Welcome back, Preview/Edit trong gio)
     -> KHOA cuon trang phia sau. iOS Safari bo qua overflow:hidden tren body nen dung cach body position:fixed + nho vi tri. */
  (function () {
    var dangKhoa = false, viTri = 0;
    function capNhat() {
      /* 08/10 user (iPhone 16 Pro Max): mo CART DRAWER / popup mon di kem van luot duoc trang sau -> khoa luon (chi mobile; desktop Horizon cuon trong .page-wrapper) */
      var mo = !!document.querySelector(matchMedia('(max-width:749px)').matches ? 'dialog.tkc-hop[open], dialog.color-custom-drawer[open], dialog.tk-upx[open]' : 'dialog.tkc-hop[open]');
      if (mo === dangKhoa) return;
      dangKhoa = mo;
      var b = document.body, h = document.documentElement;
      if (mo) {
        viTri = window.scrollY || h.scrollTop || 0;
        h.classList.add('tkc-khoa-cuon');
        b.style.position = 'fixed'; b.style.top = -viTri + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
      } else {
        h.classList.remove('tkc-khoa-cuon');
        b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
        /* 07/10 (user): theme dat scroll-behavior:smooth -> tra vi tri bi "cuon tu dau trang xuong". Tat smooth tam thoi, nhay thang. */
        var cu = h.style.scrollBehavior; h.style.scrollBehavior = 'auto';
        window.scrollTo({ top: viTri, left: 0, behavior: 'instant' });
        requestAnimationFrame(function () { h.style.scrollBehavior = cu; });
      }
    }
    new MutationObserver(capNhat).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
  })();
  var g0 = document.getElementById('tk-custom');
  if (g0 && !g0.__tk) { g0.__tk = 1; TKC(g0, { che: 'pdp' }); }
})();
